import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=cabbb94c&scoped=true"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=cabbb94c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabbb94c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cabbb94c')) {
      api.createRecord('cabbb94c', component.options)
    } else {
      api.reload('cabbb94c', component.options)
    }
    module.hot.accept("./PaymentDescription.vue?vue&type=template&id=cabbb94c&scoped=true", function () {
      api.rerender('cabbb94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/subscription/PaymentDescription.vue"
export default component.exports